import { AxiosPromise } from "axios";
import { authorizedApi, BaseApi } from "../../shared/api/BaseApi";
import { GetBusinessLinesDto } from "./api/GetBusinessLinesDto";

export interface UserService {
    getBusinessLines(): AxiosPromise<GetBusinessLinesDto>;
}

export class DefaultUserService implements UserService {
    private getBusinessLinesUrl: string = "/user/GetBusinessLines";

    constructor(private authorizedApi: BaseApi) {}

    getBusinessLines(): AxiosPromise<GetBusinessLinesDto> {
        return this.authorizedApi.get<GetBusinessLinesDto>(this.getBusinessLinesUrl, {});
    }
}

export class UserServiceWithResponse implements UserService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    getBusinessLines() {
        return Promise.resolve(this._response);
    }
}

export default new DefaultUserService(authorizedApi);
